import styled from "styled-components";
import { Stepper, Step } from "react-form-stepper";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export type StepType = {
  label: string;
};

interface StepperProps {
  steps?: Array<StepType>;
  activeStep?: number;
  onClick?: any;
}
interface ConnectorStyleInterface {
  disabledColor: string;
  activeColor: string;
  completedColor: string;
  size: React.ReactText;
  stepSize: React.ReactText;
  style: string;
}

interface StepStyleInterface {
  activeBgColor: string;
  activeTextColor: string;
  completedBgColor: string;
  completedTextColor: string;
  inactiveBgColor: string;
  inactiveTextColor: string;
  size: string | number;
  circleFontSize: string | number;
  labelFontSize: string | number;
  borderRadius: string | number;
  fontWeight: string | number;
}

/**
 * @description props 로 받아와야할것들 -----------
 * activeStep : 현재 진행중인 단계 index
 * steps : 단계
 */
const tempSteps = [
  { label: "Connection" },
  { label: "Other Information" },
  // { label: "Step 3" },
];
// -------------------------------------------

function StepperComponent(props: StepperProps): JSX.Element {
  const steps = props.steps ? props.steps : tempSteps;
  const activeStep = props.activeStep ? props.activeStep : 0;
  const ConnectorStyleProps: ConnectorStyleInterface = {
    disabledColor: COLORS.GRAY,
    activeColor: COLORS.GRAY,
    completedColor: COLORS.COMPANY,
    size: 5,
    stepSize: "1.7em",
    style: "solid",
  };

  const StepStyleDTO: StepStyleInterface = {
    activeBgColor: COLORS.GRAY,
    activeTextColor: COLORS.GRAY,
    completedBgColor: COLORS.COMPANY,
    completedTextColor: "#aaa",
    inactiveBgColor: COLORS.GRAY,
    inactiveTextColor: COLORS.GRAY,
    size: "30px",
    circleFontSize: "0.9rem",
    labelFontSize: "20px",
    borderRadius: "50%",
    fontWeight: "normal",
  };
  return (
    <StepperContainer
      length={steps.length}
      className="stepper-container"
      $clickable={!!props.onClick}
    >
      <Stepper
        activeStep={activeStep}
        connectorStateColors={true}
        connectorStyleConfig={ConnectorStyleProps}
        styleConfig={StepStyleDTO}
      >
        {steps.map((step, index) => (
          <Step
            key={index}
            label={step.label}
            active={activeStep < index}
            completed={activeStep >= index}
            className="LabelCenter"
            onClick={
              props.onClick
                ? () => props.onClick("step", index)
                : () => console.log(index, "????")
            }
            data-testid={`blocks-stepper-step-${index}-click`}
          >
            {/* active Step 현재 진행중인 단계가 지나면 주황색상 원 표시 위함 */}
            <Circle active={activeStep > index} />
            <Label active={activeStep >= index}>{step.label}</Label>
          </Step>
        ))}
      </Stepper>
    </StepperContainer>
  );
}

const StepperContainer = styled.div<{ length: number; $clickable: boolean }>`
  padding: 35px 0;
  width: calc(${({ length }) => 100 + 100 / length}% + 48px);

  // 기존 라벨
  #RFS-Label {
    display: none;
  }

  // Stepper 전체
  #RFS-StepperContainer {
    padding: 0;
  }

  // 연결 선 위치 조절 (사이즈 조절할때마다 같이 조절해줘야함)
  #RFS-ConnectorContainer {
    top: 50%;
    transform: translateY(-50%);
    left: calc(-50% + 15px);
    right: calc(50% - 15px);
  }

  // 연결 부분 padding 제거
  #RFS-StepContainer {
    padding: 0;
  }

  // 라벨 위치 조절 위해 position relative
  .LabelCenter {
    position: relative;
  }
  button {
    cursor: ${({ $clickable }) => ($clickable ? "pointer" : "not-allowed")};
    p {
      width: 20px !important;
      height: 20px !important;
    }
    span span {
      top: auto !important;
      bottom: 100%;
      margin-bottom: 13px;
    }
  }

  ${mediaQuery.isMobile} {
    width: 100%;
  }
`;

// active Step 현재 진행중인 단계 지나면 원 bgcolor 주황색
const Circle = styled.p<{ active: boolean }>`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: ${({ active }) => (active ? COLORS.COMPANY : COLORS.WHITE)};
`;

const Label = styled.span<{ active: boolean }>`
  position: absolute;
  left: 50%;
  top: -105%;
  font-size: ${calcRem(16)};
  text-align: center;
  transform: translateX(-50%);
  white-space: nowrap;

  color: ${({ active }) => (active ? COLORS.COMPANY : COLORS.GRAY)};

  ${mediaQuery.isMobile} {
    font-size: ${calcRem(13)};
    white-space: normal;
    top: -120%;
    /* border: 1px solid red; */
  }
`;

export default StepperComponent;
